import type { TOC } from "@ember/component/template-only";

export interface EmptyStatePointsSignature {
  Args: {
    items?: readonly string[];
  };
}

const EmptyStatePoints: TOC<EmptyStatePointsSignature> = <template>
  {{#if @items}}
    <ul
      class="flex flex-col items-center gap-1 text-sm text-gray-500 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-0 [&>li]:whitespace-nowrap sm:[&>li+li]:before:content-['·'_/_''] sm:[&>li+li]:before:mx-2 sm:[&>li+li]:before:text-gray-400"
      data-test-empty-state-points
    >
      {{#each @items as |item|}}
        <li>{{item}}</li>
      {{/each}}
    </ul>
  {{/if}}
</template>;

export default EmptyStatePoints;
